import React from 'react';
import { Link } from 'react-router-dom';
//import './App.css';

function mainMenu() {
  return (
    <div>
    <h1>{sessionStorage.nameSupp}</h1>
    <div className="main_menu_container">
      <div className="main_menu_column">
        <Link to="/neworder"><h2>Create New Order</h2></Link>
      </div>
      <div className="main_menu_column"></div>
      <div className="main_menu_column"></div>
    </div>
    </div>
  );
}

export default mainMenu;